import { parseAsString, useQueryStates } from 'nuqs'

// Define all filter parsers - align with useInvoiceQuery expected parameters
const categoryFilterParsers = {
  // Search query
  search: parseAsString.withDefault('').withOptions({
    clearOnDefault: true,
  }),
}

export function useCategoryFilters() {
  const [filters, setFilters] = useQueryStates(categoryFilterParsers, {
    history: 'replace', // Use replace to avoid cluttering browser history
    shallow: true, // Client-side only updates
  })

  // Helper functions for easier state management
  const updateSearch = (search: string) => {
    setFilters((prev) => ({ ...prev, search }))
  }

  const clearAllFilters = () => {
    // Clear all filters in a single atomic operation to prevent step-by-step clearing
    setFilters({
      search: '',
    })
  }

  // Check if any filters are active (excluding defaults)
  const hasActiveFilters = filters.search !== ''

  return {
    // Current filter values
    filters,

    // Update functions
    updateSearch,
    setFilters,
    clearAllFilters,

    // Helper states
    hasActiveFilters,
  }
}

// Type exports for better TypeScript support
export type CategoryFilters = ReturnType<typeof useCategoryFilters>['filters']
export type CategoryFilterKey = keyof typeof categoryFilterParsers
